import type { MediaEpisode } from "@/mocks/media";

interface EpisodeListProps {
  episodes: MediaEpisode[];
  onPlay: (episode: MediaEpisode) => void;
}

export default function EpisodeList({ episodes, onPlay }: EpisodeListProps) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-list-check-2 text-primary-600" aria-hidden="true"></i>
          剧集列表
        </h2>
        <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
          共 {episodes.length} 集
        </span>
      </div>

      <ul className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        {episodes.map((episode) => (
          <li key={episode.id}>
            <button
              type="button"
              onClick={() => onPlay(episode)}
              className="group flex w-full cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-3.5 py-3 text-left transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-sm font-bold text-background-50 transition-colors group-hover:bg-accent-500">
                {episode.index}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-foreground-900">
                  {episode.title}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-500">{episode.duration}</span>
              </span>
              <i
                className="ri-play-circle-line text-xl text-foreground-400 transition-colors group-hover:text-primary-600"
                aria-hidden="true"
              ></i>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}